import { render } from "./Vouchers.vue?vue&type=template&id=8cabb1f4"
import script from "./Vouchers.vue?vue&type=script&lang=js"
export * from "./Vouchers.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__